var _FilterList;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { string } from 'prop-types';
import clsx from 'clsx';
import { FilterList } from 'mosaic-react-icons';
import { styled } from '@mui/material/styles';
import Badge, { badgeClasses } from '@mui/material/Badge';
import SovosIconButton from '../sovos-icon-button/SovosIconButton';
import useMosaicTranslation from '../internals/i18n/useMosaicTranslation';
const StyledBadge = styled(Badge, {
  shouldForwardProp: prop => prop !== 'color'
})(_ref => {
  let {
    color,
    theme: {
      palette
    }
  } = _ref;
  return {
    ["& .".concat(badgeClasses.badge)]: {
      backgroundColor: color || palette.primary.main,
      color: palette.common.white
    }
  };
});

/**
 * `SovosToolbarFilter` (opens the filter drawer) **Note**: must be a child
 * of `SovosToolbarActions`
 *
 * Props from the SovosIconButton
 */
const SovosToolbarFilter = _ref2 => {
  let {
    appliedFiltersCount,
    className,
    color,
    tooltipText,
    ...props
  } = _ref2;
  const {
    t
  } = useMosaicTranslation();
  return /*#__PURE__*/React.createElement(SovosIconButton, _extends({}, props, {
    className: clsx('sovosToolbarFilter__button', className),
    color: color,
    tooltipText: tooltipText || t('toolbarFilter.tooltip')
  }), /*#__PURE__*/React.createElement(StyledBadge, {
    badgeContent: appliedFiltersCount > 0 ? appliedFiltersCount : 0
  }, _FilterList || (_FilterList = /*#__PURE__*/React.createElement(FilterList, null))));
};
SovosToolbarFilter.propTypes = {
  /**
   * Number of filters that have been applied
   */
  appliedFiltersCount: props => {
    const {
      appliedFiltersCount
    } = props;
    const count = Number.parseInt(appliedFiltersCount, 10);
    if (Number.isNaN(count)) {
      return new Error('`appliedFiltersCount` is not a number');
    }
    if (!/^[0-9]\d*$/.test(count)) {
      return new Error("Invalid prop (no negative numbers allowed) 'appliedFiltersCount': '".concat(count, "' supplied to 'SovosToolbarFilter'"));
    }
    return null;
  },
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * One of the Material UI theme colors, `primary`, `default`, etc. or a
   * custom css Hex color string
   */
  color: string,
  /**
   * Tooltip for the icon
   */
  tooltipText: string
};
SovosToolbarFilter.defaultProps = {
  appliedFiltersCount: 0
};
export default SovosToolbarFilter;